import { render, staticRenderFns } from "./message-center-list.vue?vue&type=template&id=322f68c9&scoped=true&"
import script from "./message-center-list.vue?vue&type=script&lang=js&"
export * from "./message-center-list.vue?vue&type=script&lang=js&"
import style0 from "./message-center-list.vue?vue&type=style&index=0&id=322f68c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322f68c9",
  null
  
)

export default component.exports